export default {
  path: '/',
  component: () => import('@/layouts/LayoutContentAppNav.vue'),
  meta: { protected: true },
  children: [
    {
      path: 'reports/fees',
      name: 'UniversalFeesReport',
      component: () => import('@/views/reports/FeesReport.vue'),
    },
    {
      path: 'reports/fees/pending-dues',
      name: 'UniversalPendingDuesReport',
      component: () => import('@/views/reports/PendingDuesReport.vue'),
    },
    {
      path: 'reports/fees/daily-collection',
      name: 'UniversalDailyCollectionReport',
      component: () => import('@/views/reports/FeesDailyCollectionReport.vue'),
    },
    {
      path: 'reports/fees/payment-mode-summary',
      name: 'UniversalPaymentModeSummaryReport',
      component: () => import('@/views/reports/PaymentModeSummaryReport.vue'),
    },
    {
      path: 'reports/fees/collection-summary',
      name: 'UniversalCollectionSummaryReport',
      component: () => import('@/views/reports/CollectionSummaryReport.vue'),
    },
    {
      path: 'reports/examination/low-marks',
      name: 'UniversalLowMarksReport',
      component: () => import('@/views/reports/LowMarksReport.vue'),
    },
    {
      path: 'reports/examination/class-average',
      name: 'UniversalClassAverageReport',
      component: () => import('@/views/reports/ClassAverageReport.vue'),
    },
    {
      path: 'reports/examination/marks-range',
      name: 'UniversalMarksRangeReport',
      component: () => import('@/views/reports/MarksRangeReport.vue'),
    },
    {
      path: 'reports/examination/class-register',
      name: 'UniversalClassRegisterReport',
      component: () => import('@/views/reports/ClassRegisterReport.vue'),
    },
    {
      path: 'reports/staff-attendance',
      name: 'UniversalStaffAttendanceReport',
      component: () => import('@/views/reports/StaffAttendanceReportUniversal.vue'),
    },
    {
      path: 'reports/staff-leave',
      name: 'UniversalStaffLeaveReport',
      component: () => import('@/views/reports/StaffLeaveReportUniversal.vue'),
    },
    {
      path: 'reports/staff-leave/summary',
      name: 'UniversalLeaveSummaryReport',
      component: () => import('@/views/reports/LeaveSummaryReport.vue'),
    },
    {
      path: 'reports/enquiry',
      name: 'UniversalEnquiryReport',
      component: () => import('@/views/reports/EnquiryReport.vue'),
    },
    {
      path: 'reports/enquiry/followups',
      name: 'UniversalFollowUpSummaryReport',
      component: () => import('@/views/reports/FollowUpSummaryReport.vue'),
    },
    {
      path: 'reports/homework',
      name: 'UniversalHomeworkReport',
      component: () => import('@/views/reports/HomeworkReportUniversal.vue'),
    },
  ],
}
